import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  strmail = `
  " Roland Groz ; lig-vasco,Morritz Halm ; [lig-vasco] ; (Save the date) Soutenance / PhD Defence Manh-Dung Nguyen ; Manh-Dung Nguyen (PhD candidate, Vasco group, with CEA-List in Saclay) will defend his thesis on: Tuesday March 30, 14:00. The title of the thesis is: Binary-level Directed Fuzzing for Complex Vulnerabilities. Regards.; vide ; 15/03/2021; 11:53 ;"
  " Communication SHS ; etu-2020-shs ; [etu-2020-SHS] ; Enquete de satisfaction transports en commun ; Bonjour Je vous diffuse une enquête de satisfaction menée par des étudiants en Géographie et Aménagement de l'UGA. Je vous remercie pour l'attention que vous porterez à cette enquête. Mes camarades et moi travaillons en ce moment sur une enquête de satisfaction sur les transports en commun, dans le cadre d'un de nos cours de notre cursus de géographie et aménagement. https://forms.gle/wFKHbV6BtURyrgMd8 Merci d'avance ; vide ; 15/03/2021 ; 10:43 "
  " Mehdi Mhalla ; lig-tous ; [lig-tous] ; Séminaire QuEnG candidat professeur CAPP Mercredi 24 Mars a 15:00 ; Bonjour à tous, je vous prie de trouver ci-dessous une annonce pour un séminaire. Nous accueillerons Mischa Woods, candidat à un poste de professeur Grenoble INP Ensimag dans l'équipe CAPP. Participer à la réunion Zoom https://univ-grenoble-alpes-fr.zoom.us/j/99450197551?pwd=OVV3Z0xibTQ5RXdqVUlrL1NXK09kUT09 Cordialement ; vide ; 15/03/2021 ; 10:25 "
  " ORNELA CELA ; lig-tous ; MAUD CHORIER ; [lig-tous] ; Soutenance de thèse Ornela Cela ; [English version below] Bonjour à toutes et à tous, J’ai le plaisir de vous annoncer la soutenance de ma thèse de doctorat intitulée «Two contributions to Continual Evolution: CEFOP, a method for Business Process Continuous Improvement and As-IS/As-IF, a methodological framework for Continual Evolution Methods Engineering » qui aura lieu le Mercredi 17 Mars 2021 à 13h30. ; vide ; 15/03/2021 ; 07:08 "
  " FREDERIC PROST ; lig-tous ; [lig-tous] ; TIC Talk du LIG : épisode 20 - Enseignement à distance ; Bonjour à tous, pour le vingtième épisode des TIC Talk du LIG je reçois Claire Peltier qui est Professeure adjointe au Département enseignement et apprentissage de la Faculté des Sciences de l'Education de l'Université Laval (Québec) et chercheuse associée à l'Université de Genève. Nous discutons d'un sujet en plein coeur de l'actualité : les transformations de l'enseignement du fait des nouvelles technologies.  L'enseignement est sûrement le domaine qui a le plus été impacté par les nouvelles technologies de l'information mais aussi par la crise sanitaire actuelle. L'apprentissage à distance est devenu, contrain et forcé, la norme. Nous discutons dans cet épisode des implications de cette transformation massive et brutale. De la manière de transmettre la connaissance à sa réception tout en passant par son évaluation nous passons en revue les évolutions récentes et partageons autour des expériences que nous vivons tous actuellement. ; vide ; 12/03/2021 ; 16:02 "
  " communication-universite ; etu-2020 ; [etu-2020] ; Participez aux Journées de la francophonie ! ; Nous vous invitons à célébrer la francophonie, lors des Journées de la francophonie qui se dérouleront en ligne du 18 au 20 mars 2021. Les événements proposés tout au long de ces journées rendent hommage à la richesse et à la diversité culturelles de l’Afrique francophone, que l'UGA a choisi de mettre à l’honneur en cette année 2021 ! ; vide ; 12/03/2021 ; 15:21 "
  " Sophie Dupuy Chessa ; M1 WIC ; ; Nouveau message de Sophie Dupuy Chessa ; Bonjour, un QCM noté aura lieu lors du cours de Système décisionnel du lundi 22 mars. Toute absence non justifiée donnera lieu à un 0. Merci de me prévenir en cas de problème. Bonne journée ; 12/03/2021 ; 09:31 "
  " communication-universite ; etu-2020 ; [etu-2020] ;  Proj'expo 2021, le forum des étudiants entrepreneurs;Toute l'équipe de Pépite oZer est heureuse de vous inviter à entrer dans l’univers des étudiants qui créent leur activité … ; vide ; 12/03/2021 ; 08:30 "
  " Luca Bisognin ; etu-2020-shs-ham1md161@univ-grenoble-alpes.fr ; [etu-2020-shs-HAM1MB161] ; Cours 3 ce vendredi 12/03 à 15h15 ; Voici le lien ZOOM pour notre cours de demain, vendredi 12.03, de 15h15 à 17h15 en introduction aux méthodes agiles (UE Gestion de Projet). https://univ-grenoble-alpes-fr.zoom.us/j/93560342651?pwd=dU1aYVd3bDJvUEdlYXRSL1FiVDlOZz09 Très bonne soirée. ; vide ; 11/03/2021 ; 19:07 "
  `

  strdoc = `
  " Certificat de scolarité ; 15/08/2020 ; PDF "
  " ATTESTATION DE REUSSITE AU DIPLOME ; 23/06/2020 ; PDF "
  " Relevé de notes Session 1 2019/2020 ; 23/06/2020 ; PDF"
  " Notification de bourse ; 18/06/2020 ; PDF "
  " Relevé de notes Session 1 2018/2019 ; 03/03/2020 ; PDF "
  " ATTESTATION DE REUSSITE AU DIPLOME ; 11/07/2019 ; PDF "
  `
  tab: any;
  semestre: number = 8;


  @Input() appareilName: string;
  name: string = "";
  id: string = "";
  ind: number = 0;

 

  name1: string = "searchMail";
  name2:string = "searchDoc"


  constructor() {
    this.appareilName = "";
  }

  ngOnInit(): void {
    this.tab = this.chooseTab();
    if (this.appareilName == "docs") {
      this.name = "Mes documents";
      this.id = "doc";
    }
    else if(this.appareilName == "mails") {
      this.name = "Mes mails";
      this.id = "mail";
    }
    console.log(this.tab);
  }

  chooseTab() {
    if (this.appareilName == "docs") {
      console.log(this.parseD(this.strdoc));
      return this.parseD(this.strdoc);
    }
    else {
      console.log("parseM");
      return this.parseM(this.strmail);
    }
  }

  setId(event :any) {
    console.log(event);
    console.log(event.target.id);
    this.ind = event.target.id;

  }

  sendMail(id: number) {
    console.log("sendEmail");
    return [this.tab[id].de, this.tab[id].a,this.tab[id].cc, this.tab[id].objet, this.tab[id].message, this.tab[id].pieces, this.tab[id].date,  this.tab[id].heure];
  }

  sendDoc(id: number) {
    console.log("senDoc");
    return [this.tab[id].nom, this.tab[id].date, this.tab[id].type];
  }



  rechercheDocuments() {
    let input, filter, ul, li, a, i, txtValue;
    input = (<HTMLInputElement>document.getElementById("inputDocuments"));
    filter = input.value.toUpperCase();
    ul = document.getElementById("ulDocuments");
    if(ul != null){
    li = ul.getElementsByTagName("li");
    for (i = 0; i < li.length; i++) {
      a = li[i].getElementsByTagName("a")[0];
      txtValue = a.textContent || a.innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        li[i].style.display = "";
      } else {
        li[i].style.display = "none";
      }
    }
  }
  }
  
  rechercheMails() {
    let input, filter, ul, li, a, i, txtValue;
    input = (<HTMLInputElement>document.getElementById("inputMail"));
    filter = input.value.toUpperCase();
    ul = document.getElementById("ulMail");
    if (ul != null) {
      li = ul.getElementsByTagName("li");
      for (i = 0; i < li.length; i++) {
        a = li[i].getElementsByTagName("a")[0];
        txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          li[i].style.display = "";
        } else {
          li[i].style.display = "none";
        }
      }
    }
  }

  parseD(str: string): DOC[] {

    const L: DOC[] = str.trim().split("\n").map(s => s.trim()).filter(s => s !== "")

      .map(s => s.split(";").map(s => s.slice(1, -1)))

      .map(([n,d,t]) => ({

        nom: n,
         
        date: d,

        type:t,

                 }));

    return L;

  }

  parseM(str: string): MAIL[] {

    const L: MAIL[] = str.trim().split("\n").map(s => s.trim()).filter(s => s !== "")

      .map(s => s.split(";").map(s => s.slice(1, -1)))

      .map(([d, a, c, o,m,p, da,h]) => ({

                  de: d,

                   a: a,
                     
                   cc: c,

                   objet: o,
                   
                   message: m,
        
                   pieces:p,
                   
                   date: da,

                   heure:h,

                 }));

    return L;

  }

}


interface DOC{

  nom: string;

  date: string;

  type: string;

}

interface MAIL{

  de: string;

  a: string;

  cc: string;

  objet: string;

  message: string;

  pieces: string;

  date: string;

  heure: string;

}
